module.exports = __webpack_public_path__ + "img/comprado.a06499ed.png";